import React, {Component} from 'react';
import Layout from '../components/Layout/Layout';
import Offers from "../components/Offers/Offers";
import {bindActionCreators} from "redux";
import {getMainData} from "../actions/card";
import {connect} from "react-redux";
import {urlParam} from "../helpers/urlParam";
import axios from 'axios';
import Widget from "../components/Widget/Widget"
import {
  getUtmFromStorage,
  pushUrlWithUtm,
  saveUtmToStorage,
  utmProps
} from "../helpers/linkWithUtm";

class StartScreen extends Component {

  state = {
    widgets: null
  }

  async componentDidMount() {
    this.props.getMainData();
    this.getWidgets();

    saveUtmToStorage();

    //если в url есть хоть один из параметров меток, не восстанавливаем из хранилища
    if(!utmProps.some(param => urlParam(param))) {
      let params = getUtmFromStorage();
      if(params)
        await pushUrlWithUtm(params);
      try {
        window.yaCounter38953865.hit(window.location.href)
      } catch (error) {
        console.log('error last screen analytics', error);
      }
    }
  }

  getWidgets() {
    let url = new URL(`${process.env.REACT_APP_API_SITE}/widgets`);
    url.searchParams.set('page', /*'tariff.fitron.club'*/ window.location.hostname);
    let self = this;
    axios({
      method: 'get',
      url: url,
      headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json',
      },
    }).then(function(response) {
      if(response.data.data && response.data.data.length)
        self.setState({widgets:response.data.data})
    })
    .catch(function (error) {
      self.setState({widgets: null});
    });
  }

  render(){
    return(
      <Layout page="start">
        <Offers history={this.props.history} />
        {
          this.state.widgets && this.state.widgets.map((widgetData, key) => {
            return <Widget data={widgetData} key={key}/>
          })
        }
      </Layout>
    )
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  getMainData,
}, dispatch);

export default connect(null, mapDispatchToProps)(StartScreen);